export default {
  title: {
    interview: '面试安排'
  },
  label: {
    information: '面试信息：',
    company: '公司',
    job: '职位',
    organizer: '组织者',
    interviewer: '面试官',
    candidate: '候选人',
    status: '状态',
    selectTime: '请选择一个时间：',
    scheduled: '面试时间：',
    cancelInterview: '确定取消面试吗？',
    suggestInterview: '如果没有时间合适，点击确认，我们会让面试官提供更多可选择的时间。',
    suggestedNewTime: '已请求更多面试时间',
    canceled: '面试已取消'
  },
  btn: {
    suggestTime: '以上时间都不合适'
  },
  message: {
    selectTime: '请选择一个时间',
    confirmSuccess: '已确认面试时间',
    cancelSuccess: '已取消面试',
    suggestSuccess: '已建议新的面试时间'
  }
}
